"use strict";

import { Box, Text } from '@autoguru/overdrive';
import { memo } from 'react';
import * as styles from './VehicleLookupTitleRenderer.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const VehicleLookupTitleRenderer = /*#__PURE__*/memo(({
  suggestion
}) => {
  return /*#__PURE__*/_jsx(Box, {
    marginY: "2",
    paddingY: "1",
    paddingX: "4",
    backgroundColour: "white",
    children: /*#__PURE__*/_jsx(Text, {
      strong: true,
      as: "p",
      colour: "success",
      size: "2",
      className: styles.title,
      children: suggestion.text
    })
  });
});